import styled from 'styled-components'

export default styled('div')<{ disabled?: boolean }>`
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  user-select: none;
  transition:
    opacity 150ms ease-in-out,
    transform 150ms linear;
  &:active,
  &:focus {
    opacity: 0.5;
  }
  &:hover {
    /* if disabled is true, then there will be no visual difference when you hover in or out */
    opacity: ${(props) => (props.disabled ? 1 : 0.75)};
  }
`
